<!-- START: pages/page-404 -->
<div class="text-center">
    <div class="w-50 d-inline-block pt-5 pb-5 mt-5 mb-5">
        <h1 class="mb-4"><strong>Error 404</strong></h1>
        <p class="mb-4">The page you are looking for does not exist; it may have been moved, or removed altogether. You might want to try the search function. Alternatively, return to the front page.</p>
        <a href="javascript: history.back();" class="btn btn-link">Go Back</a>
    </div>
</div>
<!-- END: pages/page-404 -->